/**
 * The Experiences Section JavaScript
 * File: assets/the-experiences.js
 * Handles: Category tab filtering, video badge interactions, video lightbox modal, and Shopify Customizer events.
 */

(function () {
  'use strict';

  function initExperiencesSection(section) {
    if (!section) return;

    const tabButtons = section.querySelectorAll('.experiences__tab-btn');
    const cards = section.querySelectorAll('.experiences__card');
    const modal = section.querySelector('.experiences-modal');
    const modalVideo = modal ? modal.querySelector('.experiences-modal__video') : null;
    const modalClose = modal ? modal.querySelector('.experiences-modal__close') : null;
    const modalOverlay = modal ? modal.querySelector('.experiences-modal__overlay') : null;

    // --------------------------------------------------------------------------
    // 1. Tab Filtering
    // --------------------------------------------------------------------------
    tabButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        const selectedTab = this.getAttribute('data-tab');

        // Update active tab button
        tabButtons.forEach((b) => {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });

        // Filter cards with smooth entrance animation
        cards.forEach((card) => {
          const cardCategory = (card.getAttribute('data-category') || '').trim().toLowerCase();
          const target = (selectedTab || '').trim().toLowerCase();

          if (target === 'all' || cardCategory === target) {
            card.classList.remove('is-hidden');
            card.classList.remove('is-animating-in');
            void card.offsetWidth; // Trigger reflow for animation
            card.classList.add('is-animating-in');
          } else {
            card.classList.add('is-hidden');
            card.classList.remove('is-animating-in');
          }
        });
      });
    });

    // --------------------------------------------------------------------------
    // 2. Video Lightbox Playback
    // --------------------------------------------------------------------------
    function openVideoModal(videoSrc, isExternal) {
      if (!modal || !videoSrc) return;

      const videoContainer = modal.querySelector('.experiences-modal__video-container');
      if (videoContainer) {
        if (isExternal && (videoSrc.includes('youtube.com') || videoSrc.includes('vimeo.com') || videoSrc.includes('youtu.be'))) {
          // Embed iframe
          let embedUrl = videoSrc;
          if (videoSrc.includes('youtube.com/watch?v=')) {
            embedUrl = videoSrc.replace('watch?v=', 'embed/') + '?autoplay=1';
          } else if (videoSrc.includes('youtu.be/')) {
            embedUrl = videoSrc.replace('youtu.be/', 'www.youtube.com/embed/') + '?autoplay=1';
          }
          videoContainer.innerHTML = `<iframe src="${embedUrl}" class="experiences-modal__video" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
        } else {
          // Native MP4 / WebM video
          videoContainer.innerHTML = `<video src="${videoSrc}" class="experiences-modal__video" controls autoplay playsinline></video>`;
        }
      }

      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';

      if (modalClose) modalClose.focus();
    }

    function closeVideoModal() {
      if (!modal) return;
      modal.classList.remove('is-active');
      document.body.style.overflow = '';

      const videoContainer = modal.querySelector('.experiences-modal__video-container');
      if (videoContainer) {
        const vid = videoContainer.querySelector('video');
        if (vid) vid.pause();
        videoContainer.innerHTML = '';
      }
    }

    // Attach click events on video badges and cards with video
    cards.forEach((card) => {
      const videoSrc = card.getAttribute('data-video-src');
      const isExternal = card.getAttribute('data-video-external') === 'true';
      const videoBadge = card.querySelector('.experiences__video-badge');

      if (videoSrc) {
        if (videoBadge) {
          videoBadge.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openVideoModal(videoSrc, isExternal);
          });
        }
      }
    });

    if (modalClose) modalClose.addEventListener('click', closeVideoModal);
    if (modalOverlay) modalOverlay.addEventListener('click', closeVideoModal);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-active')) {
        closeVideoModal();
      }
    });
  }

  // DOM ready init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-section-type="experiences-grid"]').forEach(initExperiencesSection);
    });
  } else {
    document.querySelectorAll('[data-section-type="experiences-grid"]').forEach(initExperiencesSection);
  }

  // Shopify Theme Customizer events
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.getAttribute('data-section-type') === 'experiences-grid') {
      initExperiencesSection(e.target);
    } else {
      const sec = e.target.querySelector('[data-section-type="experiences-grid"]');
      if (sec) initExperiencesSection(sec);
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    const block = e.target;
    if (block && block.classList.contains('experiences__card')) {
      block.classList.remove('is-hidden');
      block.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });
})();
